import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { ParaworkJobTypeTermsQuery } from '@custom/schema';

export const useParaworkJobTypeTermsQuery = () =>
  useStaticQuery(graphql(ParaworkJobTypeTermsQuery));
